<template>
  <v-tooltip bottom max-width="320">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        x-small
        class="help-hint"
        v-bind="attrs"
        v-on="on"
        :aria-label="label"
      >
        <v-icon size="16">mdi-help-circle-outline</v-icon>
      </v-btn>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "HelpHint",
  props: {
    text: { type: String, required: true },
    label: { type: String, default: "Ayuda" },
  },
};
</script>

<style scoped>
.help-hint {
  color: #5c6f87 !important;
  margin-left: 4px;
}
.help-hint:hover {
  color: #223b6a !important;
}
</style>
